import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { LoadingPage } from 'Components/';
import { Filter, Main } from 'Containers/';
import { FNS874_REPORT_FORM_NAME } from 'Common/FormEnum';
import { GenerateReport } from 'Common/ObjectHelper';
import { errorToast } from 'Common/ToastHelper';

import { FNS874ReportForm } from './components/FNS874ReportForm';
import { getReport, clearReport, resetError } from 'State/report/actions';
import {
  getReportData,
  getReportError,
  getReportFetching,
} from 'State/selectors';

class FNS874ReportContainer extends Component {
  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: FNS874_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          disabled: loading,
          loading,
        },
        shown: true,
      },
    };
  };

  componentDidUpdate(prevProps) {
    const { clearReport, resetError } = this.props;

    errorToast(this.props, prevProps, 'error', resetError);

    GenerateReport(
      this.props,
      prevProps,
      'FNS-874 Report',
      'report',
      clearReport
    );
  }

  handleSubmit = values => {
    const { getReport } = this.props;
    getReport('Reports/FNS874Report', values);
  };

  render() {
    const { loading } = this.props;
    return (
      <Fragment>
        {loading && <LoadingPage />}
        <Filter title={'FNS-874 Report'} />
        <Main {...this.getMainProps()}>
          <FNS874ReportForm onSubmit={this.handleSubmit} />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    report: getReportData(state),
    error: getReportError(state),
    loading: getReportFetching(state),
  };
};

const mapDispatchToProps = {
  getReport,
  clearReport,
  resetError,
};

export const FNS874Report = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FNS874ReportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/fns874/FNS874Report.js